const myOrganizationsSearchActions = {
  MY_ORGANIZATIONS_SEARCH_INIT_STATE_SET: 'MY_ORGANIZATIONS_SEARCH_INIT_STATE_SET',
  MY_ORGANIZATIONS_SEARCH_PROP_UPDATE: 'MY_ORGANIZATIONS_SEARCH_PROP_UPDATE',
  MY_ORGANIZATIONS_SEARCH_PROP_DELETE: 'MY_ORGANIZATIONS_SEARCH_PROP_DELETE'
};
export default myOrganizationsSearchActions;
